import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import { useState } from "react";
// import { BsPencil } from "react-icons/bs";
import getBookingFormattedDate, {
  convertTo12HourFormat,
} from "../../Config/Booking";
import { InstantExpertModal } from "../Modals/InstantExpertModal";
import BookingService from "../../services/Booking";
import { TherapyDateTimeModal } from "../Modals/TherapyDateTimeModal";
export const SingleMasterBookingRow = ({ props, func }: any) => {
  const {
    booking_id,
    booking_date,
    booking_time,
    session_date,
    lead_information: { email, first_name, last_name },
    expert_information: { full_name, role },
    payment_information: { amount, payment_id },
    cart_information: { promocode },
    subscription: {
      subscription_sequence,
      session_count,
      subscription_booking_id,
    },
    session_time,
    booking_status,
    booking_type,
    post_session_status,
    createdAt,
    code,
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState<any>("");
  const [bookingStatus, setBookingStatus] = useState<any>(booking_status);
  const getMenuItems = (type: string) => {
    if (type === "PENDING") {
      return ["INSTANT", "BOOKED", "CANCELLED"];
    } else if (type === "INSTANT") {
      return ["APPROVED", "CANCELLED"];
    } else return [type];
  };
  const handleStatus = (el: string) => {
    if (el === "APPROVED") {
      setModal("INSTANT");
      onOpen();
    } else if (el === "BOOKED") {
      BookingService.updateConfirmBooking(booking_id)
        .then((res) => {
          setBookingStatus(el);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      BookingService.updatePreBookingStatus(booking_id, el)
        .then((res) => {
          setBookingStatus(el);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };
  const getBookingType = (
    sequence: number,
    session_count: string,
    booking_id: string
  ) => {
    if (sequence === 0) {
      return "Single";
    } else if (sequence === 1) {
      return `${session_count} Session Subscription`;
    } else {
      return `Use Subscription ${sequence}/${session_count} ${booking_id}`;
    }
  };

  // console.log(createdAt);
  const formatDate = () => {
    const originalDateTime = DateTime.fromISO(createdAt, { zone: "utc" });
    const modifiedDateTimeInIndia = originalDateTime.setZone("Asia/Kolkata");

    return modifiedDateTimeInIndia.toFormat("dd/LLL/yy");
  };
  return (
    <tr>
      <td>
        <span style={{ color: "red", fontWeight: "bolder", fontSize: "0.7em" }}>
          {code || ""}
        </span>{" "}
        {booking_id}
      </td>
      <td>{formatDate()}</td>
      <td>
        <div>{getBookingFormattedDate(booking_date)}</div>
        <div>{convertTo12HourFormat(booking_time)}</div>
      </td>
      <td>
        <div>{getBookingFormattedDate(session_date)}</div>
        <div> {session_time}</div>
      </td>
      <td>{email}</td>
      <td>
        {first_name} {last_name}
      </td>
      <td>{full_name}</td>
      <td>{role}</td>
      <td>{booking_type}</td>
      <td>
        {" "}
        {getBookingType(
          subscription_sequence,
          session_count,
          subscription_booking_id
        )}{" "}
      </td>
      {
        <td>
          <Menu isLazy>
            <MenuButton className="statusCell">
              <Flex>
                <Box> {bookingStatus}</Box>
                {bookingStatus && (
                  <Box>
                    {" "}
                    <ChevronDownIcon />
                  </Box>
                )}
              </Flex>
            </MenuButton>
            <MenuList>
              {getMenuItems(bookingStatus).map((el) => (
                <MenuItem onClick={() => handleStatus(el)}>{el}</MenuItem>
              ))}
            </MenuList>
          </Menu>
          {/* {booking_status}
        {(
          <span className="tdEditIcon">
            <ChevronDownIcon />
          </span>
        )} */}
        </td>
      }
      <td>{post_session_status || ""}</td>
      <td>{payment_id ? "Paid" : ""}</td>
      <td>{amount}</td>
      <td>{promocode}</td>
      <td>
        <button
          type="button"
          className={
            post_session_status === "RESCHEDULED"
              ? "btn action-btn"
              : "btn action-btn disabledButton"
          }
          onClick={() => {
            if (post_session_status === "RESCHEDULED") {
              setModal("THERAPYDATEMODAL");
              onOpen();
            }
          }}
          disabled={post_session_status !== "RESCHEDULED"}
        >
          Update
        </button>
      </td>
      {modal === "THERAPYDATEMODAL" && (
        <TherapyDateTimeModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={booking_id}
        />
      )}
      {modal === "INSTANT" && (
        <InstantExpertModal isOpen={isOpen} onClose={onClose} id={booking_id} />
      )}
    </tr>
  );
};
